'use client';

import { Typography } from '@coolblue-development/freddy';
import { useTranslation } from '@i18n/useTranslation';

type Props = {
  count: number;
};

export const ResultCounter = ({ count }: Props) => {
  const { t } = useTranslation('filterPage');
  return (
    <Typography variant='h2' mb={0}>
      {t('vacancyCount', { count })}
    </Typography>
  );
};
